var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var type = 'moderator-access';
var MODERATOR = 'MODERATOR';
var MEMBER = 'MEMBER';

var ModeratorAccessController = /*#__PURE__*/function () {
  "use strict";

  function ModeratorAccessController(firstModerator, options) {
    _classCallCheck(this, ModeratorAccessController);

    this._capabilityTypes = [MODERATOR];
    this._write = []; // Allowed to add other mods or members

    this._firstModerator = firstModerator;

    this._write.push(this._firstModerator);

    this._members = Boolean(options.members);
    if (this._members) this._capabilityTypes.push(MEMBER);
    this._encKeyId = options.encKeyId;
  }

  _createClass(ModeratorAccessController, [{
    key: "isMod",
    value: function isMod(id) {
      return this._write.includes(id);
    }
  }, {
    key: "isValidCapability",
    value: function isValidCapability(capability) {
      return this._capabilityTypes.includes(capability);
    }
  }, {
    key: "firstModerator",
    get: function get() {
      return this._firstModerator;
    }
  }, {
    key: "canAppend",
    value: function () {
      var _canAppend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(entry, identityProvider) {
        var entryID, capability, idAdd, isMod, validCapability, validSig;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                entryID = entry.identity.id;
                capability = entry.payload.value.capability;
                idAdd = entry.payload.value.id;
                isMod = this.isMod(entryID);
                validCapability = this.isValidCapability(capability);

                validSig = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            return _context.abrupt("return", identityProvider.verifyIdentity(entry.identity));

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function validSig() {
                    return _ref.apply(this, arguments);
                  };
                }();

                _context2.t0 = isMod && validCapability;

                if (!_context2.t0) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 10;
                return validSig();

              case 10:
                _context2.t0 = _context2.sent;

              case 11:
                if (!_context2.t0) {
                  _context2.next = 17;
                  break;
                }

                if (!(capability === MODERATOR)) {
                  _context2.next = 16;
                  break;
                }

                if (!(idAdd === this.firstModerator)) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return", true);

              case 15:
                this._write.push(idAdd);

              case 16:
                return _context2.abrupt("return", true);

              case 17:
                return _context2.abrupt("return", false);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function canAppend(_x, _x2) {
        return _canAppend.apply(this, arguments);
      }

      return canAppend;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(address) {
        var addList, suffix, mod;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                addList = address.split('/');
                suffix = addList.pop();
                this._members = suffix === 'members';
                mod = suffix.includes('mod') ? suffix : addList.pop();
                this._firstModerator = mod.split('_')[1];

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function load(_x3) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var address, manifest;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // TODO if entire obj saved in manfest, can just pass our own fields
                address = "".concat(type, "/mod_").concat(this._firstModerator);
                address += this._members ? '/members' : '';
                manifest = {
                  address: address
                };
                if (this._encKeyId) manifest.encKeyId = this._encKeyId;
                return _context4.abrupt("return", manifest);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }], [{
    key: "type",
    get: function get() {
      return type;
    }
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(orbitdb) {
        var options,
            firstModerator,
            members,
            encKeyId,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};

                if (options.address) {
                  members = options.address.includes('members');
                  firstModerator = options.address.split('/')[1].split('_')[1];
                  encKeyId = options.encKeyId;
                } else {
                  members = options.members;
                  firstModerator = options.firstModerator;
                  encKeyId = options.encKeyId;
                }

                if (firstModerator) {
                  _context5.next = 4;
                  break;
                }

                throw new Error('Moderator AC: firstModerator required');

              case 4:
                return _context5.abrupt("return", new ModeratorAccessController(firstModerator, {
                  members: members,
                  encKeyId: encKeyId
                }));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function create(_x4) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return ModeratorAccessController;
}();

module.exports = ModeratorAccessController;